import {useUi} from './config';

export type CardMarkerEffect='chip'|'ink';
// One saved design setting applies to every player; old browser choices are ignored.
export function useCardMarkerEffect():{effect:CardMarkerEffect}{
 const {controls}=useUi();
 return {effect:controls.cardMarkerEffect==='chip'?'chip':'ink'};
}
